// src/components/ConsultationForm/WorkPreferencesSection.js
import React from 'react';
import { Form, ButtonGroup, ToggleButton } from 'react-bootstrap';

const WorkPreferencesSection = ({ formData, onChange }) => {
  // Options definitions.
  const workTypeOptions = [
    { value: 'Permanent', label: 'Permanent' },
    { value: 'Temporary', label: 'Temporary' },
    { value: 'Vacation Coverage', label: 'Vacation Coverage' },
  ];

  const contractTypeOptions = [
    { value: 'W2', label: 'W2' },
    { value: '1099', label: '1099' },
  ];

  const compensationTypeOptions = [
    { value: 'Hourly', label: 'Hourly' },
    { value: 'Salary', label: 'Salary' },
  ];

  // Reusable helper function for toggle button groups.
  // inputType defaults to "checkbox" for multi-select.
  const renderToggleButtonGroup = (
    name,
    groupLabel,
    options,
    selectedValues,
    inputType = 'checkbox',
    styleOverride = { minWidth: '140px' },
    variant = 'outline-primary'
  ) => (
    <Form.Group controlId={name} className="mb-4">
      <Form.Label className="h6" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
        {groupLabel} <span className="text-danger">*</span>
      </Form.Label>
      <ButtonGroup className="d-flex flex-wrap">
        {options.map((option, idx) => {
          const uniqueId = `${name}_${option.value}_${idx}`;
          const checked =
            inputType === 'radio'
              ? selectedValues === option.value
              : (selectedValues || []).includes(option.value);
          return (
            <ToggleButton
              key={uniqueId}
              id={uniqueId}
              type={inputType}
              variant={variant}
              name={name}
              value={option.value}
              checked={checked}
              onChange={onChange}
              className="m-1"
              style={styleOverride}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </ButtonGroup>
    </Form.Group>
  );

  return (
    <>
      <Form.Group controlId="formLocationPreference" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold' }}>
          Preferred Location <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          placeholder="e.g., Philadelphia, PA"
          name="locationPreference"
          value={formData.locationPreference}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group controlId="formRadiusPreference" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold' }}>
          Radius Preference (miles)
        </Form.Label>
        <Form.Control
          type="number"
          placeholder="e.g., 50"
          name="radiusPreference"
          value={formData.radiusPreference}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group controlId="formYearsOfExperience" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold' }}>
          Years of Experience <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="number"
          placeholder="e.g., 5"
          name="yearsOfExperience"
          value={formData.yearsOfExperience}
          onChange={onChange}
        />
      </Form.Group>
      {renderToggleButtonGroup(
        'desiredWorkType',
        'Desired Type of Work',
        workTypeOptions,
        formData.desiredWorkType || [], // now an array for multi-select
        'checkbox'
      )}
      {renderToggleButtonGroup(
        'availability.contractType',
        'Desired Contract Type',
        contractTypeOptions,
        formData.availability.contractType || [],
        'checkbox'
      )}
      <Form.Group controlId="compensation.type" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
          Compensation Type <span className="text-danger">*</span>
        </Form.Label>
        <ButtonGroup className="d-flex flex-wrap">
          {compensationTypeOptions.map((option, idx) => {
            const uniqueId = `compensationType_${option.value}_${idx}`;
            return (
              <ToggleButton
                key={uniqueId}
                id={uniqueId}
                type="radio"
                variant="outline-primary"
                name="compensation.type"
                value={option.value}
                checked={formData.compensation?.type === option.value}
                onChange={onChange}
                className="m-1"
                style={{ minWidth: '140px' }}
              >
                {option.label}
              </ToggleButton>
            );
          })}
        </ButtonGroup>
      </Form.Group>
      <Form.Group controlId="compensation.amount" className="mb-4">
        <Form.Label className="h6" style={{ fontWeight: 'bold' }}>
          Desired {formData.compensation?.type === 'Salary' ? 'Annual Salary' : 'Hourly Rate'} <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter desired amount"
          name="compensation.amount"
          value={formData.compensation?.amount || ''}
          onChange={onChange}
        />
      </Form.Group>
    </>
  );
};

export default WorkPreferencesSection;
